import { useSyncExternalStore } from "react";

// For full implementation: https://www.epicreact.dev/use-sync-external-store-demystified-for-practical-react-development-w5ac0

const MOBILE_BREAKPOINT = 768;
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const getSnapshot = () => window.matchMedia(QUERY).matches;

const subscribe = (callback: () => void) => {
	const mediaQueryList = window.matchMedia(QUERY);
	mediaQueryList.addEventListener("change", callback);
	return () => mediaQueryList.removeEventListener("change", callback);
};

export function useIsMobile() {
	return useSyncExternalStore(subscribe, getSnapshot);
}
